var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.651b6bdd.svg";
export { ForwardRef as ReactComponent };